module.exports = __webpack_public_path__ + "static/media/04.a628668f.jpg";